<template>
  <div
    v-if="buttonList.length"
    class="mt-5 md:mt-10 flex items-center flex-wrap"
  >
    <div
      v-for="(btn, i1) in buttonList"
      :key="`home-button-${i1 + 1}`"
      class="mr-2 last:mr-0 mb-2"
    >
      <MultiBtn
        :route-to="btn.routeTo"
        icon="arrow"
        size="large"
        :theme="buttonStyle"
        :text="btn.labels.btn_text"
        :label="btn.labels.btn_title"
      />
    </div>
  </div>
</template>

<script>
import MultiBtn from '@/components/buttons/MultiBtn.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonList',

  components: {
    MultiBtn
  },

  computed: {
    // Data
    ...mapGetters([
      'homePage',
      'mainMenuPage',
      'aoiPage',
      'guidedTourPage',
      'justExplorePage',
      'myStore'
    ]),
    // Buttons
    buttonStyle() { return this.myStore(['styles', 'home_screen', 'buttons', 'button_style']) ?? 'button_style_2' },
    buttonList() {
      // Data
      const { mainMenuPage, aoiPage, guidedTourPage, justExplorePage } = this
      const homeLabels = this.myStore(['labels', 'home_screen']) ?? {}
      const navMethodPages = []
      // Main Menu
      const mainMenuEnabled = this.myStore(['settings', 'main_menu_enabled']) ?? false
      const mainMenuButtonLabels = homeLabels.main_menu_button ?? false
      const addMainMenu = mainMenuPage && mainMenuButtonLabels && mainMenuEnabled
      if (addMainMenu) {
        navMethodPages.push({
          labels: mainMenuButtonLabels,
          routeTo: mainMenuPage.routeTo
        })
        return navMethodPages
      }
      // Area of interest
      const areaOfInteresEnabled = this.myStore(['settings', 'areas_of_interest_enabled']) ?? false
      const areaOfInteresButtonLabels = homeLabels.area_of_interest_button ?? false
      const addAreaOfInterest = aoiPage && areaOfInteresButtonLabels && areaOfInteresEnabled
      if (addAreaOfInterest) {
        navMethodPages.push({
          labels: areaOfInteresButtonLabels,
          routeTo: aoiPage.routeTo
        })
      }
      // Guided tout
      const guidedTourEnabled = this.myStore(['settings', 'guided_tour_enabled']) ?? false
      const guidedTourButtonLabels = homeLabels.guided_tour_button ?? false
      const addGuidedTour = guidedTourPage && guidedTourButtonLabels && guidedTourEnabled
      if (addGuidedTour) {
        navMethodPages.push({
          labels: guidedTourButtonLabels,
          routeTo: guidedTourPage.routeTo
        })
      }
      const justExploreButtonLabels = homeLabels.just_explore_button ?? false
      const addJustExplore = justExplorePage && justExploreButtonLabels && !addAreaOfInterest
      if (addJustExplore) {
        navMethodPages.push({
          labels: justExploreButtonLabels,
          routeTo: justExplorePage.routeTo
        })
      }
      return navMethodPages
    }
  }
}
</script>

